
/*
The current implementation of the session is not clear. In fact, the backend should be separated in two. One managing the AI / mindmap functions
suh as qa and assistant, while the second would manage the chat system proper. For the tim being, a common mongo db is used to store users, states,
and AI / mapmind aspects. The session persistence is not ensured yet and this forces the user to logout correctly for retrieving the stored state
at when reconnecting.
*/


 async function createTempDemoSpace(socket, tempLogin, map_name='Journal de bord') {

    if (tempLogin) {
      try {
  // Émettre l'événement
         socket.emit('createDemoUser', { tempLogin, map_name }, (error) => {
            if (error) {
                console.error('Erreur lors de la créatin de demo :', error);
            } else {
                console.log('Création de démo demandée ok');
            }
        });
      } catch (error) {
          console.error('Erreur globale lors de la demande de création de démo :', error);
      }
    }
  };
 
export default createTempDemoSpace;